import {
  Semantics,
  SemanticsList,
  ThemeTokensSemantic,
  useThemeTokensSemantic,
} from "shared/theme/sidespor/theme/themeSemantics";
import { SystemStyleObject } from "shared/theme/sidespor/types";

export const defineCompounds = (
  definitionFunction: (
    theme: ThemeTokensSemantic,
    semantic: Semantics,
  ) => { css: SystemStyleObject },
) =>
  SemanticsList.map((semantic) => {
    const themeSemantic = useThemeTokensSemantic(semantic);
    return definitionFunction(themeSemantic, semantic);
  });
